var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2)
        for (var i = 0, l = from.length, ar; i < l; i++) {
            if (ar || !(i in from)) {
                if (!ar)
                    ar = Array.prototype.slice.call(from, 0, i);
                ar[i] = from[i];
            }
        }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { mobileOptions, pcOptions } from "@/interface/status";
import { isPC } from "@/util/help";
import $ from "jquery";
function convertDataURIToBinary(base64data) {
    //编码转换
    var raw = window.atob(base64data); //这个方法在ie内核下无法正常解析。
    var rawLength = raw.length;
    var array = new Uint8Array(new ArrayBuffer(rawLength));
    var i = 0;
    for (i = 0; i < rawLength; i++) {
        array[i] = raw.charCodeAt(i) & 0xff;
    }
    return array;
}
export function basetoBlob(base64data) {
    var u8arr = convertDataURIToBinary(base64data);
    var mine = "application/pdf"; //固定为pdf格式
    return new Blob([u8arr], { type: mine });
}
export function getLanguage(language, isReverse) {
    var options = isPC ? __spreadArray([], pcOptions, true) : __spreadArray([], mobileOptions, true);
    var _options = options.find(function (item) {
        return isReverse ? item.value !== language : item.value === language;
    });
    if (_options) {
        var obj = _options;
        return obj;
    }
    else {
        var _value = localStorage.getItem("locale") ||
            localStorage.getItem("defaultLng") ||
            "zh";
        return {
            value: _value,
            label: isPC
                ? _value === "zh"
                    ? "中文"
                    : "英文"
                : _value === "zh"
                    ? "中文"
                    : "English",
        };
    }
}
// 判断当前页面是在微信还是浏览器中打开
export var userAgentObj = function () {
    var isWeiXin = false, isApp = false, isZfb = false, isIOS = false, isAndroid = false, obj = {};
    if (/micromessenger/.test(window.navigator.userAgent.toLowerCase())) {
        //用微信打开
        isWeiXin = true;
    }
    else if (/AlipayClient/.test(window.navigator.userAgent)) {
        //用支付宝打开
        isZfb = true;
    }
    else {
        //用其他浏览器打开
        isApp = true;
    }
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        isIOS = true;
        //ios环境
    }
    else if (navigator.userAgent.match(/android/i)) {
        isAndroid = true;
        //安卓环境
    }
    obj = Object.assign({ isWeiXin: isWeiXin, isApp: isApp, isZfb: isZfb, isIOS: isIOS, isAndroid: isAndroid });
    localStorage.setItem("userAgentObj", JSON.stringify(obj));
    return obj;
};
// 修改头部标题的函数-----兼容微信和浏览器
export var ChangePageTitle = function (title) {
    var userAgentObj = JSON.parse(localStorage.getItem("userAgentObj")) || null;
    if (!userAgentObj)
        return;
    //微信或浏览器内
    var $body = $("body");
    document.title = title; //普通浏览器用这一句就可以修改了
    var $iframe = $('<iframe style="display: none"></iframe>');
    $iframe
        .on("load", function () {
        setTimeout(function () {
            $iframe.off("load").remove();
        }, 0);
    })
        .appendTo($body);
};
// 跳转
export function openInNewTabWithNoopener(url) {
    // const aTag = document.createElement('a');
    // aTag.rel = 'noopener';
    // aTag.target = "_blank";
    // aTag.href = url;
    // aTag.click();
    if (navigator.userAgent.match(/(iPhone|iPod|iPad);?/i)) {
        //如果是iOS平台(window.open在ios平台会被拦截)
        window.location.href = url;
    }
    else if (navigator.userAgent.match(/android/i)) {
        window.open(url);
    }
}
//获取base64
export function getBase64(img, callback) {
    var reader = new FileReader();
    reader.addEventListener("load", function () { return callback(reader.result); });
    reader.readAsDataURL(img);
}
export var setImgVertical = function (imgSrc, orientation) {
    return new Promise(function (resolve, reject) {
        var image = new Image();
        if (!imgSrc)
            return;
        var type = imgSrc.split(";")[0].split(":")[0];
        var encoderOptions = 1;
        image.src = imgSrc;
        image.onload = function () {
            var imgWidth = this.width;
            var imgHeight = this.height;
            var canvas = document.createElement("canvas");
            var ctx = canvas.getContext("2d");
            if (!ctx)
                return;
            canvas.width = imgWidth;
            canvas.height = imgHeight;
            if (orientation && orientation !== 1) {
                switch (orientation) {
                    case 6:
                        canvas.width = imgHeight;
                        canvas.height = imgWidth;
                        ctx.rotate(Math.PI / 2);
                        ctx.drawImage(this, 0, -imgHeight, imgWidth, imgHeight);
                        break;
                    case 3:
                        ctx.rotate(Math.PI);
                        ctx.drawImage(this, -imgWidth, -imgHeight, imgWidth, imgHeight);
                        break;
                    case 8:
                        canvas.width = imgHeight;
                        canvas.height = imgWidth;
                        ctx.rotate((3 * Math.PI) / 2);
                        ctx.drawImage(this, -imgWidth, 0, imgWidth, imgHeight);
                        break;
                }
            }
            else {
                ctx.drawImage(this, 0, 0, imgWidth, imgHeight);
            }
            resolve(canvas.toDataURL(type, encoderOptions));
        };
        image.onerror = function (e) { return reject(e); };
    });
};
